export const STATUS_PREMIO_FUTEBOL_COLOR = {
  "GANHOU": "primary",
  "PERDEU": "danger",
  "EM ABERTO": "secondary",
  "CANCELADO": "danger",
};
